const schema = () => ({
  title: 'Quelques plats',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['eyebrow', 'heading', 'description'],
    },
    {
      id: 'dish1',
      title: 'Plat 1',
      fields: ['dish1_name', 'dish1_desc', 'dish1_image'],
    },
    {
      id: 'dish2',
      title: 'Plat 2',
      fields: ['dish2_name', 'dish2_desc', 'dish2_image'],
    },
    {
      id: 'dish3',
      title: 'Plat 3',
      fields: ['dish3_name', 'dish3_desc', 'dish3_image'],
    },
  ],
  properties: {
    eyebrow: {
      title: 'Surtitre',
      type: 'string',
      default: 'Quelques plats',
    },
    heading: {
      title: 'Titre',
      type: 'string',
      default: 'Ce qui sort de la cuisine.',
    },
    description: {
      title: 'Description',
      type: 'string',
    },
    dish1_name: {
      title: 'Nom du plat 1',
      type: 'string',
    },
    dish1_desc: {
      title: 'Description du plat 1',
      type: 'string',
    },
    dish1_image: {
      title: 'Image du plat 1',
      type: 'string',
      widget: 'object_browser',
      mode: 'image',
    },
    dish2_name: {
      title: 'Nom du plat 2',
      type: 'string',
    },
    dish2_desc: {
      title: 'Description du plat 2',
      type: 'string',
    },
    dish2_image: {
      title: 'Image du plat 2',
      type: 'string',
      widget: 'object_browser',
      mode: 'image',
    },
    dish3_name: {
      title: 'Nom du plat 3',
      type: 'string',
    },
    dish3_desc: {
      title: 'Description du plat 3',
      type: 'string',
    },
    dish3_image: {
      title: 'Image du plat 3',
      type: 'string',
      widget: 'object_browser',
      mode: 'image',
    },
  },
  required: [],
});

export default schema;
